
export default function ListItem({ item }) {
  if (item[1] === 'I DONT KNOW') {
    return <span>I Don't Know</span>;
  } else {
    return <span>{item[0].toFixed(2)}</span>;
  }
}
